export default __webpack_public_path__ + "static/media/iconManutecao.ae300747.svg";